<input #field
       type="text"
       class="form-control"
       [ngModel]="innerValue"
       (ngModelChange)="writeValue($event)"
       maxlength="11"
       (blur)="onTouched()"
       autocomplete="off">
